import { Clear } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function ImageZoom({
  selectedImage,
  bottomContainerHeight,
  onClose,
}: {
  selectedImage: string;
  bottomContainerHeight: number;
  onClose: () => void;
}) {
  // Encode the URL to handle spaces and special characters
  // We use encodeURI instead of encodeURIComponent to preserve the URL structure
  const encodedImageUrl = encodeURI(selectedImage);

  const [clickedLeft, setClickedLeft] = useState(1);
  const [bgPosition, setBgPosition] = useState("50% 50%");

  const handleMouseMove = (e: React.MouseEvent<HTMLImageElement>) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setBgPosition(`${x}% ${y}%`);
  };

  useEffect(() => {
    setClickedLeft(1);
  }, [selectedImage]);

  return (
    <>
      <Clear
        sx={{
          position: "fixed",
          fontSize: "2rem",
          top: 64,
          right: 0,
          zIndex: 1001,
          color: "white",
          cursor: "pointer",
          backgroundColor: "red",
        }}
        onClick={() => {
          onClose();
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: 64,
          left: 0,
          width: "100%",
          height: `calc(100% - ${bottomContainerHeight}px - 64px)`,
          zIndex: 1000,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
        }}
      >
        <Box
          sx={{ width: "50%", height: "100%" }}
          onClick={() => {
            if (clickedLeft === 1) {
              setClickedLeft(2);
            } else if (clickedLeft === 2) {
              setClickedLeft(3);
            } else if (clickedLeft === 3) {
              setClickedLeft(4);
            } else if (clickedLeft === 4) {
              setClickedLeft(1);
            }
          }}
        >
          <img
            onMouseMove={handleMouseMove}
            style={{
              cursor: "crosshair",
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            src={encodedImageUrl}
            alt="Selected product image"
          />
        </Box>
        <Box sx={{ width: "50%", height: "100%", backgroundColor: "red" }}>
          <Typography
            sx={{
              position: "fixed",
              fontSize: "1rem",
              zIndex: 1001,
              color: "white",
              backgroundColor: "black",
              marginLeft: "0.5rem",
              marginTop: "0.5rem",
              padding: "0.5rem",
              borderRadius: "0.5rem",
            }}
          >
            {200 * clickedLeft + "%"}
          </Typography>

          <div
            style={{
              cursor: "not-allowed",
              width: "100%",
              height: "100%",
              backgroundImage: `url(${encodedImageUrl})`,
              backgroundPosition: bgPosition,
              backgroundSize: 200 * clickedLeft + "%",
              backgroundRepeat: "no-repeat",
            }}
          />
        </Box>
      </Box>
    </>
  );
}
